import type { ClinicIdType } from '@app/icare/entities/clinic/schema/Clinic'
import { ContactPersonTable } from '@app/icare/routes/_app/apotheken/-components/ContactPersonTable'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/kliniken/$id/contact-persons')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ContactPersonTable ownerId={Route.useParams().id as ClinicIdType} />
}
